function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-195.58 -97.587)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.26458 0 0 .26458 182.74 99.1)",
  fill: "none"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(48.563 -5.7158)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m3.9375 0c-0.72188 0-1.3125 0.64688-1.3125 1.4375v20.125c0 0.7906 0.59062 1.4375 1.3125 1.4375h13.125c0.7219 0 1.3125-0.6469 1.3125-1.4375v-15.812l-5.25-5.75z",
  fill: "#e2e5e7"
}), /*#__PURE__*/React.createElement("path", {
  d: "m14.438 5.75h3.9375l-5.25-5.75v4.3125c0 0.79063 0.5906 1.4375 1.3125 1.4375z",
  fill: "#b0b7bd"
}), /*#__PURE__*/React.createElement("path", {
  d: "m18.375 10.062-3.9375-4.3125h3.9375z",
  fill: "#cad1d8"
}), /*#__PURE__*/React.createElement("path", {
  d: "m15.75 18.688c0 0.3953-0.2953 0.7187-0.6562 0.7187h-14.438c-0.36094 0-0.65625-0.3234-0.65625-0.7187v-7.1875c0-0.3953 0.29531-0.7188 0.65625-0.7188h14.438c0.3609 0 0.6562 0.3235 0.6562 0.7188z",
  fill: "#f15642"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "m2.7116 14.135c0.12075-1.1155 1.6577-1.316 2.3815-0.7065 0.357 0.3155-0.02035 0.8158-0.336 0.5628-0.38785-0.2696-1.2698-0.3961-1.3801 0.2005-0.14175 0.943 2.1414 0.4032 2.1039 1.932-0.03675 1.4598-1.9674 1.4936-2.6919 0.8388-0.17325-0.1553-0.168-0.4075-0.07284-0.5635 0.13584-0.1488 0.28809-0.2005 0.46659-0.0395 0.4305 0.3212 1.5376 0.5627 1.6164-0.2538-0.0676-0.8495-2.2503-0.3385-2.0875-1.9708z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m9.5763 16.595 0.084 0.1085c0.34587 0.345-0.105 0.9085-0.45675 0.5463l-0.17785-0.1546c-0.273 0.2063-0.59259 0.3048-1.0178 0.3048-0.92334 0-1.9786-0.6965-1.9786-2.1103s1.0493-2.1318 1.9786-2.1318c0.97519 0 1.9307 0.718 1.9307 2.1318 0 0.5463-0.12666 0.9495-0.36225 1.3053zm-0.31566-1.3053c0-0.9135-0.65559-1.3785-1.2534-1.3785-0.64509 0-1.2803 0.4643-1.2803 1.3785 0 0.6965 0.54009 1.357 1.2803 1.357 0.18835 0 0.3721-0.0517 0.55585-0.1035l-0.59785-0.6037c-0.27825-0.368 0.16275-0.8913 0.51385-0.552l0.59325 0.649c0.13059-0.2005 0.18834-0.4478 0.18834-0.7468z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m10.712 13.618c0-0.1897 0.147-0.3507 0.3308-0.3507 0.168 0 0.3097 0.1617 0.3097 0.3507v2.8793h1.4273c0.5139 0 0.525 0.7526 0 0.7526h-1.7364c-0.1837 0-0.3307-0.1431-0.3307-0.3501v-3.2818z"
})), /*#__PURE__*/React.createElement("path", {
  d: "m15.094 19.406h-12.469v0.7188h12.469c0.3609 0 0.6562-0.3234 0.6562-0.7188v-0.7187c0 0.3953-0.2953 0.7187-0.6562 0.7187z",
  fill: "#cad1d8"
}))));

function SvgSql(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "4.8617mm",
    height: "6.0854mm",
    viewBox: "0 0 4.8617 6.0854",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSql);
export default __webpack_public_path__ + "static/media/sql.ccfb72ba.svg";
export { ForwardRef as ReactComponent };